import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChangeofserviceRoutingModule } from './changeofservice-routing.module';
import { ChangeofserviceComponent } from './changeofservice.component';
import { SharedModule } from 'app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import {IvyCarouselModule} from 'angular-responsive-carousel';

@NgModule({
  declarations: [ChangeofserviceComponent],
  imports: [
    NgbModule,
    ChangeofserviceRoutingModule,
    CommonModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    SharedModule,
    ReactiveFormsModule,
    IvyCarouselModule
  ]
})
export class ChangeofserviceModule { }

